import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantLabel } from '../mutations/deleteParticipantLabel.mutation';
import type {
  DeleteParticipantLabelMutation,
  DeleteParticipantLabelMutationVariables,
} from '../types';

export const useDeleteParticipantLabelMutation = (
  options?: MutationOptions<
    DeleteParticipantLabelMutation,
    DeleteParticipantLabelMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantLabel), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
